import { render } from "./Requested.vue?vue&type=template&id=5cdd7c61"
import script from "./Requested.vue?vue&type=script&lang=js"
export * from "./Requested.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./Requested.vue?vue&type=style&index=1&id=5cdd7c61&lang=css"

import exportComponent from "/var/www/html/cradle.staging.moko.africa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__